(function () {
  const SECTION_LINKS = {
    home: '#shopify-section-hero',
    top: '#shopify-section-hero',
    'beat player': '#shopify-section-hero',
    licensing: '#shopify-section-licensing',
    license: '#shopify-section-licensing',
    licenses: '#shopify-section-licensing',
    bio: '#shopify-section-bio',
    about: '#shopify-section-bio',
    contact: '#shopify-section-contact',
    // v4.3: product-page "Keep Digging" → related beats section
    related: '#shopify-section-related',
    'keep digging': '#shopify-section-related'
  };

  const sectionOrder = [
    { key: 'home', selector: '#shopify-section-hero' },
    { key: 'licensing', selector: '#shopify-section-licensing' },
    { key: 'bio', selector: '#shopify-section-bio' },
    { key: 'contact', selector: '#shopify-section-contact' },
    { key: 'related', selector: '#shopify-section-related' }
  ];

  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function normalizeHash(anchor) {
    const raw = anchor.getAttribute('href') || '';
    if (raw.startsWith('#shopify-section-')) return raw;
    if (raw.startsWith('#')) {
      const key = raw.slice(1).toLowerCase();
      return SECTION_LINKS[key] || raw;
    }
    const textKey = (anchor.textContent || anchor.getAttribute('aria-label') || '').trim().toLowerCase();
    return SECTION_LINKS[textKey] || '';
  }

  function scrollToTarget(hash) {
    const target = hash && document.querySelector(hash);
    if (!target) return false;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    return true;
  }

  function navKeyFromHash(hash) {
    const found = sectionOrder.find(item => item.selector === hash);
    return found ? found.key : '';
  }

  function setActiveNav(key) {
    if (!key) return;
    document.querySelectorAll('.site-header__nav-link, .bottom-nav .nav-item, .v18-footer__links a').forEach(link => {
      const hash = normalizeHash(link);
      const isActive = navKeyFromHash(hash) === key;
      link.classList.toggle('is-active', isActive);
      link.classList.toggle('active', isActive && link.classList.contains('nav-item'));
      if (isActive) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  }

  function syncKnownHrefTargets() {
    document.querySelectorAll('.site-header__nav-link, .bottom-nav .nav-item, .v18-footer__links a').forEach(link => {
      if (link.hasAttribute('data-modal-open')) return;
      const hash = normalizeHash(link);
      if (hash && hash.startsWith('#shopify-section-')) link.setAttribute('href', hash);
    });
  }

  document.addEventListener('click', event => {
    const anchor = event.target.closest('a[href^="#"]');
    if (!anchor || anchor.hasAttribute('data-modal-open') || anchor.hasAttribute('data-license-modal-open')) return;
    const hash = normalizeHash(anchor);
    if (!hash || hash === '#') return;
    const target = document.querySelector(hash);
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    anchor.setAttribute('href', hash);
    if (scrollToTarget(hash)) setActiveNav(navKeyFromHash(hash));
  }, true);

  const observer = new IntersectionObserver(entries => {
    const visible = entries
      .filter(entry => entry.isIntersecting)
      .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
    if (!visible) return;
    const item = sectionOrder.find(section => visible.target.matches(section.selector));
    if (item) setActiveNav(item.key);
  }, {
    root: null,
    rootMargin: '-35% 0px -50% 0px',
    threshold: [0.08, 0.18, 0.32, 0.5]
  });

  function bootNavSync() {
    syncKnownHrefTargets();
    sectionOrder.forEach(section => {
      const node = document.querySelector(section.selector);
      if (node) observer.observe(node);
    });
    setActiveNav('home');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootNavSync);
  } else {
    bootNavSync();
  }

  window.addEventListener('load', syncKnownHrefTargets);
  document.addEventListener('shopify:section:load', syncKnownHrefTargets);
})();
